module.exports = __webpack_public_path__ + "static/scale-model-of-centennial-park-in-bakersfield-california-c1ceae7d31617fe1f98d4b0dd561eb76.png";